// src/com/arrival_to_store/ArrivalToStore.js
import React, { useEffect, useState } from 'react';
// import { styled  } from '@mui/material/styles';
import { TopContainer, TopHeader, TopContent, ControlLine, NoDataBox } from '../../common/TopStyle';
import { Box } from '@mui/system';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import { Button } from '@mui/material';
import { useLazyQuery, useReactiveVar } from '@apollo/client';
import { AppObject, AppStyle, AppWord } from '../../value/AppConst';
import { useAlertSetter } from '../../api/app-hook';
import ValueMisc from '../../value/ValueMisc';
import VzmDateField from '../../common/VzmDateField';
import IsValid from '../../value/IsValid';
import { arrivalToStoreListParamRepo, arrivalToStoreListRepo } from '../../value/AppModel';
import { LIST_ARRIVAL_TO_STORE } from './ArrivalToStoreGql';
import { GET_TRANS_PLAN_RETURN } from '../trans_plan_return/TransPlanReturnGql';
import SearchBox from '../../common/SearchBox';
import ArrivalToStoreLine from './ArrivalToStoreLine';
import ArrivalToStoreView from './ArrivalToStoreView';
import TransPlanReturnInput from '../trans_plan_return/TransPlanReturnInput';


export default function ArrivalToStore() {
    const arrivalToStoreListData = useReactiveVar(arrivalToStoreListRepo);
    const [records, setRecords] = useState([]);
    const listParam = useReactiveVar(arrivalToStoreListParamRepo);
    const [dateChanged, setDateChanged] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [sortInfo, setSortInfo] = useState({id: null, order: 0}); // -1 : descending, 0: no sorting, 1: ascending
    const [arrivalToStoreSelected, setArrivalToStoreSelected] = useState({});
    const [returnInputStatus, setReturnInputStatus] = useState({open:false, data:{}});
    const addAlert = useAlertSetter();

    // ##### Call GraphQL to get List #####
    const [getArrivalToStoreList, responseList] = useLazyQuery(LIST_ARRIVAL_TO_STORE, {
        ...AppObject.NoCachedFetch,
        onCompleted: (data, option) => {onCompleteGetList(data, option)},
		onError: (error) => addAlert({title: '도착정보 조회 오류', message: [error.message]})
    });
    // 물류집기 입력을 위해 이 데이터를 가져옴
    const [getTransPlanReturnItem, responseTprItem] = useLazyQuery(GET_TRANS_PLAN_RETURN, {
		...AppObject.NoCachedFetch,
		onCompleted: (data, option) => {onCompleteGetTransPlanReturnItem(data, option)},
		onError: (error) => addAlert({title: '물류집기 정보 조회 오류', message: [error.message]})
	});

    const getArrivalToStoreListNow = () => {
        const dateFrom = listParam.dateFrom || ValueMisc.getYMD();
        const param = {variables:{dateFrom:dateFrom, dateTill:dateFrom}};
        getArrivalToStoreList(param);
    };

    useEffect(()=>{
        let diff = new Date().getTime()/1000 - arrivalToStoreListData.when;
        if(diff > 300) {
            getArrivalToStoreListNow();
        }
    }, []);

    useEffect(()=>{
        if(!listParam.dateFrom) {
            arrivalToStoreListParamRepo({dateFrom: ValueMisc.getYMD()});
        }
    }, [listParam]);

    useEffect(() => {
        let list;
        const txt = searchText ? searchText.trim().toLowerCase() : '';
        if(IsValid.nullString(txt)) list = arrivalToStoreListData.records;
        else {
            list = arrivalToStoreListData.records.filter((item) => {
                return (
                    item.dcName.toLowerCase().includes(txt) ||
                    (item.storeName && item.storeName.toLowerCase().includes(txt)) ||
                    (item.vehPlates && item.vehPlates.toLowerCase().includes(txt))
                );
            });
        }
        if(sortInfo.id && sortInfo.order !== 0) {
            const newList = [...list].sort((a, b) => {
                const orderBy = sortInfo.order < 0 ? -1 : 1; // -1: descending, 1: ascending
                if(a[sortInfo.id] < b[sortInfo.id]) return -1 * orderBy;
                if(a[sortInfo.id] > b[sortInfo.id]) return orderBy;
                return 0;
            });
            list = newList;
        }

        setRecords(list);
    }, [searchText, arrivalToStoreListData, sortInfo]);
    // >>>>>>>>> callbacks <<<<<<<<<<<<<
    const onCompleteGetList = (data, clientOption) => {
        if(data.arrivalToStoreList) {
            const newData = {...arrivalToStoreListData};
            newData.records = data.arrivalToStoreList.map((rec)=>{
                rec.inputYn = rec.inputBool ? 'Y' : 'N';
                rec.traceYn = rec.traceStatus ? 'Y' : 'N';
                return rec;
            });
            newData.when = new Date().getTime()/1000;
            arrivalToStoreListRepo(newData);
            // arrivalToStoreInputStatusRepo({open:false, data:{}});
            setReturnInputStatus({open:false, data:{}});
        }
    };

    const onCompleteGetTransPlanReturnItem = (data, option) => {
        if(data.transPlanReturnItem) {
            setReturnInputStatus({open:true, data:data.transPlanReturnItem});
        }
        else addAlert({title:'물류집기 정보 조회 오류', message:['지정한 PLAN을 찾을 수 없습니다.']});
    };
    
    const onChangeDateFrom = (id, value) => {
        arrivalToStoreListParamRepo({dateFrom: value});
        setDateChanged(true);
    };

    const onChangeSearchText = (text) => {
        setSearchText(text);
    };

    const onClickGetList = () => {
        getArrivalToStoreListNow();
    };

    const onClickItem = (item, index) => {
        setArrivalToStoreSelected(item);
    };

    const onRequestOpenReturnInput = (item) => {
        getTransPlanReturnItem({variables: {planId:item.planId}});
    };

    const onCompleteMutateReturnData = () => {
        // reload
        getArrivalToStoreListNow();
    };

    const onClickSorter = (id, sortState) => {
        setSortInfo({id, order: sortState});
    };

    const loadingAny = responseList.loading || responseTprItem.loading;

    return(
        <TopContainer>
            <TopHeader>점포관리</TopHeader>
            <ControlLine>
                <VzmDateField
                    dict={{
                        id: 'dateFrom',
                        label: '도착일자'
                    }}
                    value={listParam.dateFrom || ''}
                    error={!IsValid.date(listParam.dateFrom)}
                    onChange={onChangeDateFrom}
                />
                <Button
                    variant={AppStyle.mui.contained}
                    color={AppStyle.mui.primary}
                    size={AppWord.SMALL}
                    startIcon={<CloudDownloadIcon />}
                    style={{marginLeft: 10}}
                    onClick={onClickGetList}
                    disabled={loadingAny || (!dateChanged && arrivalToStoreListData.records.length > 0)}
                >
                    조회
                </Button>
            </ControlLine>
            <ControlLine>
                <SearchBox
                    value={searchText}
                    onChangeText={onChangeSearchText}
                    disabled={responseList.loading}
                />
            </ControlLine>
            <ArrivalToStoreLine
                onClickSorter={onClickSorter}
                idSorted={sortInfo.id}
            />
            <TopContent>
                {
                    records.length === 0 ?
                    <NoDataBox />
                    :    
                    <Box>
                        {
                            records.map((item, index) => {
                                if(item.planId === arrivalToStoreSelected.planId) {
                                    return(
                                        <ArrivalToStoreView
                                            key={index}
                                            item={item}
                                            onClose={() => setArrivalToStoreSelected({})}
                                            onRequestOpenReturnInput={onRequestOpenReturnInput}
                                        />
                                    )
                                }
                                return (
                                    <ArrivalToStoreLine
                                        key={index}
                                        item={item}
                                        index={index}
                                        itemSelected={arrivalToStoreSelected || {}}
                                        onClick={onClickItem}
                                    />
                                )
                            })
                        }
                    </Box>
                }
            </TopContent>
            <TransPlanReturnInput
                open={returnInputStatus.open}
                onClose={() => setReturnInputStatus({open:false, data:{}})}
                item={returnInputStatus.data}
                onCompleteMutation={()=> onCompleteMutateReturnData()}
            />
        </TopContainer>
    );
}
/*

export default function TransPlanReturnInput({
    open,
    onClose,
    item, // trans_plan_return.
    onCompleteMutation,
})

*/